//chapter1
export default {
    id : 7,//chapter number
    title : '07. SBA(Solder Ball Attach) 공정 (1)',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            autoNext : 'N',//Y : yes , N: no
            nextBtn : 'Y',//Y : yes , N: no
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/07/videos/a07.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            autoNext : 'N',//Y : yes , N: no, P : popup
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            body1 : [
                '솔더 볼 접합 공정의 의의',
            ],
            body2 : [
                '솔더 볼 접합 공정의 의의에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            autoNext : 'N',//Y : yes , N: no, P: popup
            nextBtn : 'Y',//Y : yes , N: no
            order : null, // if a chapter have multiple lessons, set order please ex)
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/07/videos/07.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : '솔더 볼의 크기가 너무 작으면 솔더 볼 마운터를 이용해 솔더 볼 접합을 진행하는 것이 어려울 수가 있다.',//html available
                    answer : "1",
                    explain : '솔더 볼의 크기가 너무 작으면 솔더 볼 마운터를 이용해 솔더 볼 접합을 진행하는 것이 어려울 수가 있다.'
                },
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : '솔더 볼 접합공정에서는 130µm의 작은 크기의 솔더 볼도 공정 진행이 가능하다.',//html available
                    answer : "2",
                    explain : '300µm 크기 이상의 솔더 볼의 접합작업이 가능하며 130µm 정도의 작은 크기의 솔더 볼은 공정 진행이 불가능하다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask bg
            quizMaskStart : "../assets/images/quiz_intro_start.png",//quiz mask bg
            quizIntroText : "../assets/images/quiz_intro_text.png",//quiz mask bg
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            autoNext : 'N',//Y : yes , N: no
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            //download : 'sample.pptx',//data folder
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <li>솔더 볼 접합 공정의 의의 : 솔더 볼 접합 공정은 마킹 공정이 완료된 PCB 형태의 반도체 제품을 외부와 연결하기 위해 필요한 단자를 만드는 공정으로 솔더 볼을 PCB에 접합시키는 각각의 공정을 통해 완성되는 공정<br>
                        - 리드프레임 형태 패키지는 Lead를 통해서 외부와 연결<br>
                        - PCB를 사용하는 반도체 제품은 솔더 볼을 통해서 외부와 연결<br>
                        - PCB의 패드에 플럭스를 바르고, 솔더 볼을 마운팅한 후 리플로우 공정을 통해 솔더 볼 접합<br>
                        - 솔더 볼 접합이 완료된 후에는 플럭스를 크리닝하는 공정이 반드시 필요<br>
                        - 플럭스 dotting, 솔더 볼 마운팅을 위한 툴 필요<br>
                        - 리플로우 시 온도 분포는 여러 개의 구간으로 나누어 솔더 볼 접합이 잘될 수 있는 조건으로 진행<br>
                        - 리플로우 장비의 설정온도가 그대로 구현이 되는지 점검할 필요가 있음</li>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/07/videos/a07.mp4',
        },
    ]
}